"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyForPayout = void 0;
var payments_1 = require("../../../shared/api/kapi/v1/operations/payments");
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var core_1 = require("../../../shared/core");
var mapping_1 = require("./mapping");
var useApplyForPayout = function (_a) {
    var accountId = _a.accountId, customerId = _a.customerId;
    var kapi = core_1.configService.getConfig().kapi;
    var kapiRefundsEnabled = kapi && kapi.refunds;
    var _b = __read((0, payments_1.useCreateDirectCreditPayoutMutation)({
        refetchQueries: [payments_1.CreateDirectCreditPayoutDocument],
        awaitRefetchQueries: true,
    }), 2), kapiMutation = _b[0], kapiLoading = _b[1].loading;
    var handleKapiMutation = function (data, _a) {
        var _b = _a === void 0 ? {} : _a, onCompleted = _b.onCompleted, onError = _b.onError;
        kapiMutation({
            variables: {
                input: (0, mapping_1.mapCreatePayoutCXToKapi)(data, accountId, customerId),
            },
            onCompleted: onCompleted,
            onError: function (error) {
                onError && onError((0, mapping_1.mapCreatePayoutKapiErrorToPayoutErrorCX)(error));
            },
        });
    };
    var applyForRefundLegacyMutation = (0, legacy_queries_1.useApplyForRefundLegacyMutation)(accountId, customerId);
    var handleLegacyMutation = function (data, _a) {
        var _b = _a === void 0 ? {} : _a, onCompleted = _b.onCompleted, onError = _b.onError;
        //legacy api expects amount in pence
        var submitBody = { amount: Number((0, core_1.majorToMinor)(data.amount)) };
        if (applyForRefundLegacyMutation.status !== 'in-progress') {
            applyForRefundLegacyMutation.mutate(submitBody, {
                onError: function (error) {
                    onError && onError((0, mapping_1.mapCreatePayoutLegacyErrorToPayoutErrorCX)(error));
                },
                onSuccess: onCompleted,
            });
        }
    };
    return {
        mutate: kapiRefundsEnabled ? handleKapiMutation : handleLegacyMutation,
        loading: kapiRefundsEnabled
            ? kapiLoading
            : applyForRefundLegacyMutation.status == 'in-progress',
    };
};
exports.useApplyForPayout = useApplyForPayout;
